export default __webpack_public_path__ + "static/coverImage-9083f4cac306ebdb5e7ae0a7a8a6ab79.png";